import { Application } from "@core/Application";
import { HTTPClient } from "@core/HTTPClient";
import { DemoUser } from "@models/DemoUser";
import Utils from "@utils/Utils";
import { buildURL, SystemURL } from "./URLCatalog";
import { HTTPClientInterface, HTTPRequest } from "@core/HTTPClientInterface";
import { Logger } from "@utils/Logger";
import { PresenteeismRecord } from "@screens/view-models/CheckinsScreenViewModel";

export class DemoServices {
    private httpClient: HTTPClientInterface
    constructor(
        httpClient: HTTPClientInterface = Application.shared().coreDependencies.httpClient
    ) {
        this.httpClient = httpClient
        Logger.logObject("http client headers ID demo services", (httpClient as any)?.instanceID)

    }

    async createQontactPoint(name: string, latitude: number, longitude: number): Promise<string> {
        let data = {
            name: name,
            latitude: latitude,
            longitude: longitude,
        }

        let url = buildURL(SystemURL.Demo.postCreateQP)
        let request = new HTTPRequest()
        request.method = "POST"
        request.url = url
        request.body = data

        let response = await this.httpClient.execute(request)
        let qp = response.result
        return qp.id
    }

    async getPresenteeismTable(): Promise<Array<PresenteeismRecord>> {
        let url = buildURL(SystemURL.Demo.getPresenteeismTable)
        let request = new HTTPRequest()
        request.method = "GET"
        request.url = url

        let response = await this.httpClient.execute(request)
        return response.result
    }
}